<template>
  <div class="footer-navbar">
    <ContainerInner class="footer-navbar-inner">
      <div class="footer-navbar-copyright">{{ copyright.text }}</div>
      <div class="footer-navbar-menu">
        <TheFooterNavbarButton
          v-for="item in menu"
          :key="item.text"
          :content="item"
          :url="item.route"
          :text="item.text"
          :icon-left="item.icon" />
      </div>
    </ContainerInner>
  </div>
</template>

<script>
import ContainerInner from '@containers/ContainerInner'
import TheFooterNavbarButton from './TheFooterNavbarButton'
import { mapGetters } from 'vuex'
export default {
  name: 'TheFooterNavbar',
  components: {
    ContainerInner,
    TheFooterNavbarButton
  },
  data () {
    return {}
  },
  created () {
  },
  computed: {
    ...mapGetters({
      menu: 'footer/getMenu',
      copyright: 'footer/getCopyright'
    }),
    wysiwyg () {
      return this.copyright.text
    }
  }
}
</script>

<style lang="scss">
  .footer-navbar{
    @include media("large"){
      border-bottom: 1px solid shade(colors("topbar"), 20%);
    }

    &-copyright{
      @include media("small-medium"){
        padding: 1.5rem 2rem 0;
      }
    }

    &-inner{
      @include media("small-medium"){
        padding: 0;
        flex-direction: column-reverse;
      }
      @include media("large"){
        align-items: center;
      }
      display: flex;
      justify-content: space-between;
    }

    &-menu{
      @include media("small-medium"){
        flex-direction: column;
      }
      display: flex;
    }

  }
</style>
